import axios from "axios";
import { store } from "react-notifications-component";

export const base_uri = process.env.REACT_APP_API_BASE_URL;
export const S3baseUrl = process.env.REACT_APP_PIC_BASE_URL;
export const googleAnalyticsID = process.env.REACT_APP_GA_ID;
export const googleApiKey = process.env.REACT_APP_GOOGLE_API_KEY;

axios.defaults.headers.post["Content-Type"] = "application/json";

const toastError = (message) => {
  const title = "";
  store.addNotification({
    title,
    message,
    type: "danger",
    insert: "top",
    container: "bottom-right",
    animationIn: ["animate__animated", "animate__fadeIn"],
    animationOut: ["animate__animated", "animate__fadeOut"],
    dismiss: {
      duration: 5000,
      onScreen: true,
    },
  });
};

export async function invokeApi({
  path,
  method = "GET",
  headers = {},
  queryParams = {},
  postData = {},
}) {
  // check authenticity
  // sing request

  //console.log(base_uri + path, "API URL");

  let reqObj = {
    method: method,
    url: base_uri + path,
    headers: { ...headers },
  };

  //console.log("HEADER=>>",reqObj.headers)

  if (method === "GET") {
    reqObj["params"] = queryParams;
  }

  if (method === "POST") {
    reqObj["data"] = postData;
    reqObj["params"] = queryParams;
    //console.log("params called");
  }
  if (method === "PUT") {
    reqObj["data"] = postData;
    reqObj["params"] = queryParams;
    //console.log("params called");
  }
  if (method === "DELETE") {
    reqObj["data"] = postData;
    reqObj["params"] = queryParams;
    //console.log("params called");
  }

  let results = undefined;

  try {
    console.log("axios requestOBJ ==> ", reqObj);
    results = await axios(reqObj);
    console.log(results, "API results");
    return results.data;
  } catch (error) {
    console.log(error.response, "error.response.data.message");

    if (error.response.status === 401) {
      localStorage.clear();
      window.location.reload();
    }
    // toastError(error.response.data.message);

    return {
      code: error.response.status,
      message: error.response.data.message ? error.response.data.message : "",
    };

    if (error.response && error.response.data && error.response.data.message) {
      throw new Error(error.response.data.message);
    } else if (
      error.response &&
      error.response.status &&
      error.response.statusText
    ) {
      //console.log(error.response);
      throw new Error(error.response.statusText);
    } else {
      //console.log(error);
      throw new Error("Some thing went wrong");
    }
  }

  if (results.status !== 200) {
    throw new Error(await results.text());
  }
}
